export const getFlatIconButtonStyle = (color1: string, color2: string) => {
  return {
    backgroundColor: color1,
    color: color2,
    '&:hover': {
      backgroundColor: color1,
    },
  }
}
